// extracted by mini-css-extract-plugin
module.exports = {"scroll":"_1il5DxFe","prefectureItem":"_1tlk711_","prefectureItemText":"_21zZ6OMo","btnText":"QHvU9rtz"};